module.exports = __webpack_public_path__ + "img/novakid_logos.437ac7db.png";